import React from 'react'

import SectionHeader from '../../common/components/SectionHeader'
import BufferListItem from './BufferListItem'

import { useBufferList } from '../hooks'

import styles from './BufferList.module.css'

const BufferList = () => {
  const [
    layerIds,
    isLoading,
    isClean,
    { addBuffer, saveBuffers },
  ] = useBufferList()

  return (
    <div>
      <SectionHeader title="Actionable Intelligence">
        {isLoading && (
          <i className={styles.listLoadingIcon + ' fa fa-spinner fa-spin'}></i>
        )}
        <i className={styles.addButton + ' fa fa-plus'} onClick={addBuffer}></i>
      </SectionHeader>
      {layerIds.map((id) => (
        <BufferListItem layerId={id} key={id} />
      ))}
      {!isLoading && layerIds.length === 0 && (
        <div className={styles.noBuffers}>No Default Buffers Found.</div>
      )}
      {!isClean && (
        <div className={styles.buttonContainer}>
          <span className={styles.saveButton} onClick={saveBuffers}>
            Save
          </span>
        </div>
      )}
    </div>
  )
}
export default BufferList
